<div class="impersonation" *ngIf="profile$ | async; let profile">
  <ng-container *ngIf="profile.impersonatedBy; else notImpersonating">
    <h2>{{ 'impersonation.active.title' | translate }}</h2>
    <dl class="impersonation-details">
      <dt>{{ 'impersonation.active.acting_as' | translate }}</dt>
      <dd class="acting-as">{{ userLabel(profile) }}</dd>
      <dt>{{ 'impersonation.active.your_account' | translate }}</dt>
      <dd>{{ profile.impersonatedBy.email }}</dd>
      <ng-container *ngIf="timeLeft$ | async; let timeLeft">
        <dt>{{ 'impersonation.active.time_left' | translate }}</dt>
        <dd class="time-left">
          <ng-container *ngIf="!timeLeft.expired; else expired">
            {{ timeLeft.formatted }}
          </ng-container>
          <ng-template #expired>
            {{ 'impersonation.active.expired' | translate }}
          </ng-template>
        </dd>
      </ng-container>
    </dl>
    <app-button
      class="stop-button"
      testId="impersonation-stop"
      [redAlert]="true"
      [disabled]="pending"
      [title]="'impersonation.active.stop' | translate"
      (click)="stop()"
    ></app-button>
  </ng-container>

  <ng-template #notImpersonating>
    <ng-container *ngIf="mayStartImpersonation(profile); else notAvailable">
      <h2>{{ 'impersonation.start.title' | translate }}</h2>
      <p class="description">
        {{ 'impersonation.start.description' | translate }}
      </p>
      <form
        data-testid="impersonation-form"
        [formGroup]="form"
        (ngSubmit)="start()"
      >
        <app-qs-input
          testId="impersonation-user"
          [controllerName]="'impersonatedUser'"
          [label]="'impersonation.start.user' | translate"
          [placeholder]="'impersonation.start.user_placeholder' | translate"
          [required]="true"
        ></app-qs-input>
        <app-qs-input
          testId="impersonation-justification"
          [controllerName]="'justification'"
          [label]="'impersonation.start.justification' | translate"
          [placeholder]="
            'impersonation.start.justification_placeholder' | translate
          "
          [multiline]="true"
          [rows]="3"
          [required]="true"
        ></app-qs-input>
        <app-button
          testId="impersonation-start"
          [disabled]="form.invalid || pending"
          [title]="'impersonation.start.submit' | translate"
        ></app-button>
      </form>
    </ng-container>

    <ng-template #notAvailable>
      <p class="not-available">
        {{ 'impersonation.not_available' | translate }}
      </p>
    </ng-template>
  </ng-template>

  <section
    class="history"
    *ngIf="mayStartImpersonation(profile) || profile.impersonatedBy"
  >
    <h2>{{ 'impersonation.history.title' | translate }}</h2>
    <table *ngIf="history.length; else noHistory">
      <thead>
        <tr>
          <th>{{ 'impersonation.history.when' | translate }}</th>
          <th>{{ 'impersonation.history.impersonator' | translate }}</th>
          <th>{{ 'impersonation.history.impersonated_user' | translate }}</th>
          <th class="justification">
            {{ 'impersonation.history.justification' | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let entry of history" class="history-row">
          <td>
            <time [attr.datetime]="entry.time" [title]="formatTime(entry.time)">
              <span class="exact-time">{{ formatTime(entry.time) }}</span>
              <span class="relative-time">
                ({{ formatTimeAgo(entry.time) }})
              </span>
            </time>
          </td>
          <td>{{ userLabel(entry.impersonator) }}</td>
          <td>{{ userLabel(entry.impersonatedUser) }}</td>
          <td class="justification">{{ entry.justification }}</td>
        </tr>
      </tbody>
    </table>
    <ng-template #noHistory>
      <p class="no-history" *ngIf="!historyPending">
        {{ 'impersonation.history.empty' | translate }}
      </p>
    </ng-template>
    <app-button
      *ngIf="hasMoreHistory"
      class="load-more"
      [small]="true"
      [disabled]="historyPending"
      [title]="'impersonation.history.load_more' | translate"
      (click)="loadMoreHistory()"
    ></app-button>
  </section>
</div>
